import { readAppHandoffReturn } from "@bridewell/shared";
import { createFileRoute, Link } from "@tanstack/react-router";
import { buttonClasses } from "@/components/ui/button";
import { AuthLayout } from "@/features/auth/auth-layout";
import { socialProblemText } from "@/features/auth/social-sign-in";
import { noindexHead } from "@/features/marketing/seo";
import { t } from "@/i18n";

export const Route = createFileRoute("/auth/app-return")({ head: () => noindexHead(t("appReturn.title")), component: AppReturnPage });

/**
 * Where the system browser lands after a sign-in with Apple or Google that the Bridewell app started (the API's
 * `app-handoff`, docs/research/2026-10-one-account-plan.md §3). On a phone with the app this address is a verified link
 * (Android App Link, Apple associated domain) and the app opens instead of this page; the page only shows when the
 * browser kept it — then a tap on "Open the app" hands it over (a link followed with a tap opens the app). The code in
 * the address is worthless here: only the app that started the sign-in holds the verifier that redeems it.
 */
function AppReturnPage() {
  const back = readAppHandoffReturn(window.location.href);
  const problem = back && "problem" in back ? back.problem : null;
  return (
    <AuthLayout title={t("appReturn.title")} footer={<Link to="/login" className="font-semibold text-accent">{t("appReturn.here")}</Link>}>
      <div className="flex flex-col gap-4">
        <p className="text-[15px] text-text-secondary">{problem ? socialProblemText(problem, "signIn") : t("appReturn.body")}</p>
        {/* Same address, opened by a tap: a verified link that a redirect did not open, a tap does. */}
        <a href={window.location.href} className={buttonClasses("primary", "lg")}>{t("appReturn.open")}</a>
        <p className="text-sm text-text-tertiary">{t("appReturn.elsewhere")}</p>
      </div>
    </AuthLayout>
  );
}
